import { useEffect } from 'react'
import { useAppDispatch } from '@/store/hooks'
import { setBackUrl } from '@/store/slices/layoutSlice'

export const useSetBackUrl = (url: string, isAbsolute = false) => {
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(setBackUrl({ url, isAbsolute }))
  }, [dispatch, isAbsolute, url])
}
